// Static data moved out of component to prevent re-creation
export const skills = {
  "Frontend Development": [
    { name: "React.js", level: 90, icon: "⚛️", color: "from-blue-400 to-cyan-400" },
    { name: "JavaScript ES6+", level: 88, icon: "⚡", color: "from-yellow-300 to-orange-400" },
    { name: "HTML5 & CSS3", level: 95, icon: "🎨", color: "from-orange-400 to-red-500" },
    { name: "Tailwind CSS", level: 92, icon: "🌊", color: "from-teal-400 to-blue-500" }
  ],
  "Backend Development": [
    { name: "Python", level: 90, icon: "🐍", color: "from-yellow-400 to-green-500" },
    { name: "Django", level: 85, icon: "🎯", color: "from-green-500 to-emerald-600" },
    { name: "FastAPI", level: 88, icon: "🚀", color: "from-teal-400 to-cyan-500" },
    { name: "ASP.NET Web API", level: 78, icon: "🔷", color: "from-blue-500 to-indigo-600" }
  ],
  "Database & Cloud": [
    { name: "MySQL", level: 82, icon: "🗄️", color: "from-orange-400 to-amber-500" },
    { name: "PostgreSQL", level: 80, icon: "🐘", color: "from-blue-400 to-indigo-500" },
    { name: "MongoDB", level: 75, icon: "🍃", color: "from-green-400 to-emerald-500" },
    { name: "Git & GitHub", level: 90, icon: "📚", color: "from-gray-400 to-slate-600" }
  ],
  "AI & Modern Tools": [
    { name: "Machine Learning", level: 75, icon: "🤖", color: "from-purple-400 to-pink-500" },
    { name: "RESTful APIs", level: 88, icon: "🌐", color: "from-cyan-400 to-blue-500" },
    { name: "Responsive Design", level: 93, icon: "📱", color: "from-green-400 to-teal-500" },
    { name: "SDLC", level: 85, icon: "🔄", color: "from-indigo-400 to-purple-500" }
  ]
};

export const projects = [
  {
    id: 1,
    title: "APIGen - Intelligent API Testing Platform",
    date: "September 2024",
    description: "A revolutionary AI-powered platform that transforms API testing with intelligent automation, comprehensive analytics, and seamless integration capabilities.",
    features: [
      "AI-Powered Test Generation", 
      "Real-time Performance Analytics", 
      "Advanced Bug Tracking", 
      "OpenAI Integration"
    ],
    tech: ["React.js", "TypeScript", "ASP.NET Web API", "OpenAI GPT-4", "Azure", "SQL Server"],
    gradient: "from-blue-500 via-cyan-400 to-teal-400",
    githubUrl: "https://github.com/Seelam3653",
    liveUrl: "#",
    status: "Completed"
  },
  {
    id: 2,
    title: "PSMS - Enterprise People Management",
    date: "January 2025",
    description: "Next-generation enterprise management system featuring advanced geolocation tracking, intelligent analytics, and comprehensive workforce management capabilities.",
    features: [
      "Smart Authentication System", 
      "Real-time Geolocation Tracking", 
      "Advanced Analytics Dashboard", 
      "Expenditure Intelligence"
    ],
    tech: ["React.js", "Python Django", "PostgreSQL", "Geolocation API", "Chart.js", "Redis"],
    gradient: "from-purple-500 via-pink-400 to-rose-400",
    githubUrl: "https://github.com/Seelam3653",
    liveUrl: "#",
    status: "In Progress"
  },
  {
    id: 3,
    title: "AI Weather Companion",
    date: "February 2025",
    description: "Intelligent weather chatbot with natural language processing, voice interaction, and personalized weather insights powered by advanced AI technologies.",
    features: [
      "Voice Recognition & Synthesis", 
      "Natural Language Processing", 
      "Real-time Weather Data", 
      "Personalized Forecasts"
    ],
    tech: ["React.js", "Python FastAPI", "OpenAI Whisper", "Weather API", "WebRTC", "TensorFlow"],
    gradient: "from-green-500 via-teal-400 to-cyan-400",
    githubUrl: "https://github.com/Seelam3653",
    liveUrl: "#",
    status: "Planning"
  },
  {
    id: 4,
    title: "Portfolio Website v2.0",
    date: "Current",
    description: "Modern, responsive portfolio website built with cutting-edge technologies, featuring advanced animations, performance optimization, and accessibility features.",
    features: [
      "Modern UI/UX Design",
      "Advanced Animations",
      "Performance Optimized",
      "Accessibility Features"
    ],
    tech: ["React.js", "Tailwind CSS", "Framer Motion", "Vite", "PWA", "TypeScript"],
    gradient: "from-indigo-500 via-purple-500 to-pink-500",
    githubUrl: "https://github.com/Seelam3653",
    liveUrl: "#",
    status: "Completed"
  }
];

export const typewriterTexts = [
  'Full-Stack Developer', 
  'React Specialist', 
  'Python Enthusiast',
  'AI/ML Explorer', 
  'UI/UX Designer',
  'Problem Solver'
];

export const certifications = [
  {
    id: 1,
    title: "Python Full Stack Development Certification",
    organization: "Kosmik Technologies",
    year: "2024",
    description: "Achieved comprehensive certification covering frontend, backend, and database technologies using Python ecosystem.",
    icon: "🐍",
    gradient: "from-yellow-400 to-green-500"
  },
  {
    id: 2,
    title: "AI for India 2.0 Certification",
    organization: "Guvi through Skill India Digital",
    year: "2024",
    description: "Earned certification in artificial intelligence fundamentals and applications through a national upskilling initiative.",
    icon: "🤖",
    gradient: "from-purple-400 to-pink-500"
  },
  {
    id: 3,
    title: "AI Workplace Proficiency Certification",
    organization: "SUPERHUMAN AI Academy",
    year: "2025",
    description: "Completed advanced training in applying AI tools and technologies for professional workplace environments.",
    icon: "🚀",
    gradient: "from-cyan-400 to-blue-500"
  }
];
